export class DireccionNor{
  via : string;
  numNomVia : string;
  AcoNome : string;
  Prefijo : string;
  CuadranteUno : string;
  numeral : string;
  NumPrefijoUno : string;
  LetraPrefijo : string;
  NumPrefijoDos : string;
  CuadranteDos : string;
  CompleDirec : string;
  NumLetComp : string;
}
